import { useState } from "react";
import dayjs from "dayjs";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { Patient } from "@/@types/sintegrada/Patient";
import { getDeadPatients } from "@/services/sintegrada/patient/getDeadPatients";

import { DeadPatientsFilters } from "./DeadPatientsFilters";
import { DeadPatientsTable } from "./DeadPatientsTable";

export function DeadPatients() {
	const { uf, ibgeCode, cnes } = useCurrentAccount();
	const [startDate, setStartDate] = useState(
		dayjs().add(-1, "month").startOf("day").format("YYYY-MM-DDTHH:mm")
	);
	const [endDate, setEndDate] = useState(dayjs().endOf("day").format("YYYY-MM-DDTHH:mm"));
	const [youngerAge, setYoungerAge] = useState<number>();
	const [olderAge, setOlderAge] = useState<number>();
	const [deadPatients, setDeadPatients] = useState<Patient[]>([]);

	async function fetchData() {
		setDeadPatients(
			await getDeadPatients({
				uf,
				ibgeCode,
				cnes,
				startDate: dayjs(startDate)
					.tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
					.startOf("minute")
					.format("YYYY-MM-DDTHH:mm:ssZ"),
				endDate: dayjs(endDate)
					.tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
					.endOf("minute")
					.format("YYYY-MM-DDTHH:mm:ssZ"),
				youngerAge,
				olderAge,
			})
		);
	}

	return (
		<>
			<Row className="p-2 mb-10">
				<Col>
					<DeadPatientsFilters
						startDate={startDate}
						setStartDate={setStartDate}
						endDate={endDate}
						setEndDate={setEndDate}
						setYoungerAge={setYoungerAge}
						setOlderAge={setOlderAge}
						handleFilter={fetchData}
					/>
				</Col>
			</Row>
			<Row className="p-2">
				<Col>
					<DeadPatientsTable deadPatients={deadPatients} />
				</Col>
			</Row>
		</>
	);
}
